// extracted by mini-css-extract-plugin
module.exports = {"deleteButton":"EditPopup_deleteButton__aMAID","field":"EditPopup_field__2ioNy","text":"EditPopup_text__3tVWy"};